module.exports = __webpack_public_path__ + "img/kh.9c205ed1.png";